import { FC } from 'react';
import ViewIcon from '../../../../assets/images/svg/ViewIcon';
import { classNames } from '../../../utils';

type ViewButtonProps = {
  disabled?: boolean;
  onClick: () => void;
};

const ViewButton: FC<ViewButtonProps> = ({
  onClick,
  disabled,
}): JSX.Element => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        'focus:outline-none px-2 outline-none py-2 flex flex-row justify-center',
        disabled ? 'text-gray-light' : 'text-gray-dark',
      )}
    >
      <ViewIcon strokeWidth={2} />
    </button>
  );
};

export default ViewButton;
